var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRdnt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.951,
    cy: 47.951,
    r: 44.975,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rdnt-svg-gradient)",
    fillRule: "evenodd",
    d: "M43.73.138C30.408 1.34 18.325 7.95 10.017 18.581c-1.014 1.297-2.964 4.221-3.828 5.74-2.834 4.985-4.821 10.762-5.696 16.56-.657 4.355-.657 9.853 0 14.208 1.85 12.262 8.253 23.183 18.104 30.882 1.297 1.013 4.221 2.963 5.741 3.827 4.987 2.835 10.807 4.837 16.56 5.694 2.595.386 3.526.445 7.104.445 3.578 0 4.508-.058 7.104-.445 5.752-.858 11.573-2.859 16.56-5.694 1.519-.864 4.443-2.814 5.74-3.828 9.116-7.123 15.312-17.045 17.627-28.223.678-3.273.967-6.193.967-9.762 0-6.285-1.057-11.895-3.329-17.663-1.244-3.16-2.703-5.935-4.693-8.928-1.968-2.96-3.91-5.308-6.407-7.745C73.537 5.81 63.303 1.111 52.13.134c-2.065-.18-6.374-.178-8.4.004Zm4.628 10.912 2.234 13.656c1.062 6.494 1.961 11.881 1.998 11.972.055.134 2.07-1.274 11.107-7.761 6.072-4.36 11.23-8.058 11.463-8.22l.423-.293-.294.423c-.161.232-3.86 5.39-8.217 11.462-5.008 6.978-7.881 11.06-7.809 11.097.063.032 6.26 1.068 13.77 2.302 7.511 1.234 13.656 2.268 13.656 2.297 0 .03-6.145 1.063-13.656 2.297-7.51 1.234-13.707 2.27-13.77 2.302-.094.048 6.335 9.1 16.13 22.712l.206.286-.287-.206C61.685 65.57 52.649 59.153 52.6 59.246c-.032.063-1.07 6.26-2.305 13.771-1.235 7.51-2.267 13.656-2.293 13.656-.027 0-1.059-6.145-2.294-13.656-1.235-7.51-2.272-13.708-2.305-13.77-.048-.094-9.085 6.323-22.712 16.13l-.286.205.206-.286c9.795-13.612 16.223-22.664 16.13-22.712-.063-.032-6.26-1.069-13.771-2.303-7.51-1.233-13.656-2.267-13.656-2.296 0-.029 6.145-1.063 13.656-2.297 7.51-1.234 13.707-2.27 13.77-2.302.073-.037-2.8-4.12-7.809-11.097a6672.938 6672.938 0 0 1-8.217-11.462l-.293-.423.422.294c.233.161 5.39 3.859 11.462 8.217 6.955 4.992 11.061 7.88 11.098 7.809.032-.063 1.068-6.281 2.303-13.818 1.235-7.537 2.268-13.704 2.297-13.704.029 0 .188.832.355 1.848Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rdnt-svg-gradient",
    x1: 48,
    x2: 48,
    y1: 0,
    y2: 95.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#20A9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#493BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F00FA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdnt);
export default __webpack_public_path__ + "static/media/rdnt.d43c3be69d119990881c1dc4eb99bd9f.svg";
export { ForwardRef as ReactComponent };